import React, { Component, useState, useEffect } from 'react';
import styled from 'styled-components';
import debounce from 'debounce-promise';
import Async from 'react-select/async';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var Log =
/*#__PURE__*/
function () {
  function Log() {}

  var _proto = Log.prototype;

  _proto._log = function _log(console_func_name) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (_console = console)[console_func_name].apply(_console, args);
  };

  _proto.info = function info() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this._log.apply(this, ['log'].concat(args));
  };

  _proto.warn = function warn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this._log.apply(this, ['warn'].concat(args));
  };

  _proto.error = function error() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this._log.apply(this, ['error'].concat(args));
  };

  _proto.trace = function trace() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return this._log.apply(this, ['trace'].concat(args));
  };

  return Log;
}();

var singleton =
/*#__PURE__*/
new Log();
var base_font_size = 16; //px Everything else is REMs except maybe very thin lines, like borders.

var footer_height = 4;
var header_min_height = 4.5;
var nav_height = 3;
var button_height = 2.5;
var border = {
  radius: 4,
  width: 2
}; // Official font families

var font_family = {
  code: 'source-code-pro, Menlo, Monaco, Consolas, \'Courier New\', monospace',
  gotham: '\'Gotham Narrow SSm A\', \'Gotham Narrow SSm B\', sans-serif'
}; // Font sizes in 'rem' relative to 'base_font_size'

var font_size = {
  h1: 2.0,
  h2: 1.7,
  h3: 1.3,
  h4: 1.1,
  h5: 1.0,
  h6: 1.0,
  p: 1.0,
  div: 1.0,
  text_12: .75,
  text_14: .875
};
var spacing = {
  xs: .25,
  s: .5,
  m: 1,
  l: 1.5,
  xl: 2,
  xxl: 4
};
var marginSpacing = {
  xs: base_font_size / 4,
  s: base_font_size / 2,
  m: base_font_size,
  l: base_font_size * 1.5,
  xl: base_font_size * 2
};

var RgbColor =
/*#__PURE__*/
function () {
  function RgbColor(rgb) {
    this.rgb = rgb;
  }

  var _proto = RgbColor.prototype;

  _proto.isEqual = function isEqual(rgb) {
    return rgb === this.rgb;
  };

  _proto.toString = function toString() {
    return 'rgb(' + this.rgb + ')';
  };

  _proto.withAlpha = function withAlpha(a) {
    return 'rgba(' + this.rgb + ',' + a + ')';
  };

  return RgbColor;
}();
/*
Official ChargePoint Color Palette
https://zeroheight.com/7d45f0d70/p/26fc37-colors/i/11958762
*/


var palette = {
  black_000: '0, 0, 0',
  blue_010: '113, 156, 175',
  gray_010: '151, 151, 151',
  gray_020: '229, 229, 229',
  whitesmoke: '238, 238, 238',
  gray_040: '245, 245, 245',
  white_000: '255, 255, 255',
  hot_pink_000: '255, 105, 180',
  cp_orange: '255,122,20',
  cp_faded_orange: '255, 158, 84',
  cp_active_orange: '230,106,11',
  cp_translucent_orange: '255,233,216',
  cp_secondary_active_orange: '248, 185, 138',
  dark_orange: '192,77,1',
  light_orange: '253,194,100',
  pale_orange: '255,235,186',
  soft_orange: '255,246,231',
  cp_blue: '122,156,175',
  cp_darker_blue: '128,165,185',
  dark_blue: '82,111,128',
  light_blue: '160,195,215',
  pale_blue: '201,226,240',
  soft_blue: '237,246,251',
  rich_black: '51,50,49',
  cool_dark_gray: '120,124,128',
  cool_gray: '166,172,179',
  cool_pale_gray: '202,209,217',
  cool_soft_gray: '235,237,240',
  warm_dark_gray: '128,127,123',
  warm_gray: '179,177,172',
  warm_pale_gray: '217,214,208',
  warm_soft_gray: '242,240,233',
  charging_status_available: '102,189,57',
  charging_status_in_use: '94,151,198',
  charging_status_faulty: '233,72,49',
  alert_positive: '69,185,9',
  alert_caution: '245,223,36',
  alert_error: '233,72,49'
}; // IMPORTANT: All colors must come from approved palette colors above!!!

var colors = {
  black:
  /*#__PURE__*/
  new RgbColor(palette.black_000),
  white:
  /*#__PURE__*/
  new RgbColor(palette.white_000),
  body:
  /*#__PURE__*/
  new RgbColor(palette.white_000),
  body_text:
  /*#__PURE__*/
  new RgbColor(palette.rich_black),
  cool_gray:
  /*#__PURE__*/
  new RgbColor(palette.cool_gray),
  gray_text:
  /*#__PURE__*/
  new RgbColor(palette.gray_010),
  header:
  /*#__PURE__*/
  new RgbColor(palette.whitesmoke),
  footer:
  /*#__PURE__*/
  new RgbColor(palette.cp_blue),
  footer_border:
  /*#__PURE__*/
  new RgbColor(palette.cp_blue),
  footer_text:
  /*#__PURE__*/
  new RgbColor(palette.white_000),
  link_text:
  /*#__PURE__*/
  new RgbColor(palette.blue_010),
  modal_border:
  /*#__PURE__*/
  new RgbColor(palette.gray_010),
  modal_close_hover:
  /*#__PURE__*/
  new RgbColor(palette.gray_040),
  modal_close:
  /*#__PURE__*/
  new RgbColor(palette.rich_black),
  nav:
  /*#__PURE__*/
  new RgbColor(palette.cp_darker_blue),
  sub_nav:
  /*#__PURE__*/
  new RgbColor(palette.dark_blue),
  button_border:
  /*#__PURE__*/
  new RgbColor(palette.cp_orange),
  button_primary_hover:
  /*#__PURE__*/
  new RgbColor(palette.cp_faded_orange),
  button_primary_active:
  /*#__PURE__*/
  new RgbColor(palette.cp_active_orange),
  button_primary_background:
  /*#__PURE__*/
  new RgbColor(palette.cp_orange),
  button_primary_font:
  /*#__PURE__*/
  new RgbColor(palette.white_000),
  button_secondary_hover:
  /*#__PURE__*/
  new RgbColor(palette.cp_translucent_orange),
  button_secondary_active:
  /*#__PURE__*/
  new RgbColor(palette.cp_secondary_active_orange),
  button_secondary_background:
  /*#__PURE__*/
  new RgbColor(palette.white_000),
  button_secondary_font:
  /*#__PURE__*/
  new RgbColor(palette.cp_orange),
  button_disabled:
  /*#__PURE__*/
  new RgbColor(palette.warm_pale_gray),
  button_text_disabled:
  /*#__PURE__*/
  new RgbColor(palette.warm_gray)
}; // NOTE: This proxy will catch any missing color names not specified in colors table above.
// It will flip the color to an atrocious hot pink making it kind of hard to miss ;)

var colors_proxy_handler = {
  get: function get(target, prop, receiver) {
    if (!target.hasOwnProperty(prop)) {
      singleton.error('Missing color name:', prop);
      return new RgbColor(palette.hot_pink_000);
    }

    return Reflect.get(target, prop, receiver);
  }
};
var colors_proxy =
/*#__PURE__*/
new Proxy(colors, colors_proxy_handler);
var z_index = {
  modal: 10,
  loader: 1
};
var theme = {
  base_font_size: base_font_size,
  border: border,
  colors: colors_proxy,
  font_family: font_family,
  font_size: font_size,
  footer_height: footer_height,
  nav_height: nav_height,
  header_min_height: header_min_height,
  button_height: button_height,
  spacing: spacing,
  marginSpacing: marginSpacing,
  z_index: z_index
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  white-space: nowrap;\n  padding: ", "px;\n  background-color: ", ";\n  border: ", "px solid ", ";\n  font-size: ", "px;\n  font-family: ", ";\n  cursor: pointer;\n  text-align: center;\n  height: ", "rem;\n  font-size: ", ";\n  color: ", ";\n  margin: ", "px 0;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n    border-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonDefault =
/*#__PURE__*/
styled.button(
/*#__PURE__*/
_templateObject(), function (props) {
  return props.width ? props.width : '100%';
}, theme.marginSpacing.m, function (props) {
  return props.secondary ? theme.colors.button_secondary_background : theme.colors.button_primary_background;
}, theme.border.width, theme.colors.button_border, theme.base_font_size, theme.font_family.gotham, theme.button_height, theme.font_size.p, function (props) {
  return props.secondary ? theme.colors.button_secondary_font : theme.colors.button_primary_font;
}, theme.marginSpacing.l, function (props) {
  return props.secondary ? theme.colors.button_secondary_hover : theme.colors.button_primary_hover;
}, function (props) {
  return props.secondary ? theme.colors.button_secondary_active : theme.colors.button_primary_active;
}, theme.colors.button_text_disabled, theme.colors.button_disabled, theme.colors.button_disabled);

var Button =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Button, _Component);

  function Button() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.render = function render() {
    var _this = this;

    return React.createElement(ButtonDefault, Object.assign({}, this.props, {
      onClick: function onClick(evt) {
        if (_this.props.onClick) {
          _this.props.onClick(evt);
        }
      }
    }), this.props.children);
  };

  return Button;
}(Component);

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  z-index: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Container =
/*#__PURE__*/
styled.div(
/*#__PURE__*/
_templateObject$1(), theme.z_index.loader);

var Loader =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Loader, _Component);

  function Loader() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Loader.prototype;

  _proto.render = function render() {
    var _this$props$size, _this$props$size2;

    var width = (_this$props$size = this.props.size) !== null && _this$props$size !== void 0 ? _this$props$size : 100;
    var height = (_this$props$size2 = this.props.size) !== null && _this$props$size2 !== void 0 ? _this$props$size2 : 100;
    return React.createElement(Container, null, React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      version: "1.0",
      width: width + 'px',
      height: height + 'px',
      viewBox: "0 0 128 128"
    }, React.createElement("g", null, React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#000000",
      fillOpacity: "1"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#cccccc",
      fillOpacity: "0.2",
      transform: "rotate(30 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#cccccc",
      fillOpacity: "0.2",
      transform: "rotate(60 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#cccccc",
      fillOpacity: "0.2",
      transform: "rotate(90 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#cccccc",
      fillOpacity: "0.2",
      transform: "rotate(120 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#b2b2b2",
      fillOpacity: "0.3",
      transform: "rotate(150 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#999999",
      fillOpacity: "0.4",
      transform: "rotate(180 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#7f7f7f",
      fillOpacity: "0.5",
      transform: "rotate(210 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#666666",
      fillOpacity: "0.6",
      transform: "rotate(240 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#4c4c4c",
      fillOpacity: "0.7",
      transform: "rotate(270 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#333333",
      fillOpacity: "0.8",
      transform: "rotate(300 64 64)"
    }), React.createElement("path", {
      d: "M59.6 0h8v40h-8V0z",
      fill: "#191919",
      fillOpacity: "0.9",
      transform: "rotate(330 64 64)"
    }), React.createElement("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
      calcMode: "discrete",
      dur: "1080ms",
      repeatCount: "indefinite"
    }))));
  };

  return Loader;
}(Component);

var OrgSelection =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(OrgSelection, _Component);

  function OrgSelection(props) {
    var _props$url, _props$isDisabled, _props$defaultOrgName;

    var _this;

    _this = _Component.call(this, props) || this;
    _this.searchUrl = (_props$url = props.url) !== null && _props$url !== void 0 ? _props$url : '/backend.php/globalfilter/searchOrg';
    _this.state = {
      isDisabled: (_props$isDisabled = props.isDisabled) !== null && _props$isDisabled !== void 0 ? _props$isDisabled : false,
      defaultOrgName: (_props$defaultOrgName = props.defaultOrgName) !== null && _props$defaultOrgName !== void 0 ? _props$defaultOrgName : ''
    };
    return _this;
  }

  var _proto = OrgSelection.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var formData = new FormData();
    formData.set('user_search', '');
    formData.set('only_name', '1');
    formData.set('count', '2');
    fetch(this.searchUrl, {
      method: 'POST',
      body: formData
    }).then(function (r) {
      return r.json();
    }).then(function (result) {
      if (result.total_results == 1) {
        _this2.setState({
          defaultOrgName: result.content[0].name,
          isDisabled: true
        });

        if (typeof _this2.props.onChange === 'function') {
          _this2.props.onChange(result.content[0]);
        }
      }
    })["catch"](function (error) {
      console.log(error);
    });
  };

  _proto.render = function render() {
    var _this$props$additiona,
        _this$props$start,
        _this$props$count,
        _this3 = this,
        _this$props$placehold;

    var formData = new FormData();
    formData.set('additional_columns', (_this$props$additiona = this.props.additionalColumns) !== null && _this$props$additiona !== void 0 ? _this$props$additiona : 'currency,currencySymbol');
    formData.set('start', String((_this$props$start = this.props.start) !== null && _this$props$start !== void 0 ? _this$props$start : 0));
    formData.set('count', String((_this$props$count = this.props.count) !== null && _this$props$count !== void 0 ? _this$props$count : 25));
    var debouncedLoadOptions = debounce(function (value) {
      formData.set('user_search', value);
      return fetch(_this3.searchUrl, {
        method: 'POST',
        body: formData
      }).then(function (r) {
        return r.json();
      }).then(function (result) {
        if (result.content.length > 0) {
          return result.content;
        }

        return [];
      })["catch"](function (error) {
        console.log(error);
        return [];
      });
    }, 500);
    return React.createElement(Async, {
      isDisabled: this.state.isDisabled,
      inputValue: this.state.defaultOrgName,
      placeholder: (_this$props$placehold = this.props.placeholder) !== null && _this$props$placehold !== void 0 ? _this$props$placehold : '',
      noOptionsMessage: function noOptionsMessage() {
        var _this3$props$noRecord;

        return (_this3$props$noRecord = _this3.props.noRecordsMessage) !== null && _this3$props$noRecord !== void 0 ? _this3$props$noRecord : 'No records';
      },
      loadingMessage: function loadingMessage() {
        var _this3$props$loadingM;

        return (_this3$props$loadingM = _this3.props.loadingMessage) !== null && _this3$props$loadingM !== void 0 ? _this3$props$loadingM : 'Loading...';
      },
      onChange: this.props.onChange,
      getOptionLabel: function getOptionLabel(data) {
        return "" + data.name;
      },
      getOptionValue: function getOptionValue(data) {
        return "" + data.id;
      },
      components: {
        IndicatorSeparator: null,
        DropdownIndicator: null
      },
      loadOptions: debouncedLoadOptions,
      theme: function theme$1(componentTheme) {
        return _extends({}, componentTheme, {
          borderRadius: 0,
          colors: _extends({}, componentTheme.colors, {
            primary25: theme.colors.button_secondary_hover.toString(),
            primary50: theme.colors.button_secondary_hover.toString(),
            primary75: theme.colors.button_secondary_active.toString(),
            primary: theme.colors.button_secondary_font.toString()
          })
        });
      }
    });
  };

  return OrgSelection;
}(Component);

var SessionContext =
/*#__PURE__*/
React.createContext({
  session: {},
  updateSession: function updateSession() {}
});

var SessionProvider = function SessionProvider(props) {
  var _useState = useState({
    isLoggedIn: false
  }),
      sessionState = _useState[0],
      setSessionState = _useState[1];

  useEffect(function () {
    fetch('/index.php/nghelper/getSession').then(function (res) {
      return res.json();
    }).then(function (result) {
      var sessionState = {
        prefLangLocale: result.locale,
        isLoggedIn: result.userID ? true : false,
        dataServer: result.dataserver,
        accountsAPI: result.accountsAPI,
        l10nUnits: {
          length: result.length_unit,
          volume: result.volume_unit
        },
        currencyCode: result.currency_code,
        currencySymbol: result.currency_symbol,
        companyID: result.company_id ? result.company_id : null,
        permissions: makePermissionMap(result.taskPermissions),
        supportEmail: result.support_email,
        customerSupportNumber: result.customer_support_number,
        portalTimezone: result.portalTimezone,
        subdomain: result.subdomain,
        brandedLogoURL: result.brandedLogo ? result.brandedLogo : null,
        userInfo: {
          userFirstName: result.userFirstName,
          userFullName: result.userFullName,
          userName: result.userName,
          userRole: result.role
        },
        nosletMapCoordinates: {
          lat: result.mapData.map_latitude,
          lon: result.mapData.map_longitude
        },
        corporateUrl: result.corporate_url,
        instanceName: result.instance,
        videoTranscodingService: result.videoTranscodingService
      };
      setSessionState(sessionState);
    }, function (error) {
      console.log(error);
    });
  }, []);

  var makePermissionMap = function makePermissionMap(tasks) {
    var mapArray = tasks.map(function (task) {
      return [task, true];
    });
    return new Map(mapArray);
  };

  return React.createElement(SessionContext.Provider, {
    value: {
      session: sessionState,
      updateSession: setSessionState
    }
  }, props.children);
};

export default theme;
export { Button, Loader, OrgSelection, SessionContext, SessionProvider };